/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */

export type MeterPointAgreementProductDetailsFuelType =
  (typeof MeterPointAgreementProductDetailsFuelType)[keyof typeof MeterPointAgreementProductDetailsFuelType]

export const MeterPointAgreementProductDetailsFuelType = {
  GAS: "GAS",
  ELECTRICITY: "ELECTRICITY",
} as const
